import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {WidgetConfiguration} from "./widget-configuration";
import {MapViewConfiguration} from "./view-configuration";

@JsonObject()
export class ScaleBarConfiguration extends WidgetConfiguration {
    /**
     * The style for the scale bar.
     *
     * @default "line"
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-ScaleBar.html#style)
     */
    @JsonProperty()
    declare style: "ruler" | "line";

    /**
     * Units to use for the scale bar.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-ScaleBar.html#unit)
     */
    @JsonProperty()
    declare unit?: "metric" | "imperial" | "dual" | "non-metric";

    /**
     * A reference to the [MapView](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-MapView.html).
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-ScaleBar.html#view)
     */
    @JsonProperty()
    declare view?: MapViewConfiguration;
    /**
     * The view model for this widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-ScaleBar.html#viewModel)
     */
    // @JsonProperty()
    // declare viewModel?: ScaleBarViewModelProperties;

    constructor() {
        super();
    }
}
